import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapsable from '../../../../components/Collapsable';
import FirmSection from '../../../../components/FirmSection';
import HtmlContentBlock from '../../../../components/HtmlContentBlock';

const FirmAboutAwardsSection = props => {
  const { isEditMode, id, title, content, onEdit, onDelete } = props;

  const controls = isEditMode
    ? id
      ? [
          { caption: 'Edit', handler: onEdit },
          { caption: 'Delete', handler: onDelete },
        ]
      : [{ caption: 'Edit', handler: onEdit }]
    : null;

  const [collapsed, setCollapsed] = useState(true);

  const onViewMoreClick = () => {
    setCollapsed(!collapsed);
  };

  return (
    (content || isEditMode) && (
      <FirmSection
        title={title}
        controls={controls}
        linkCaption={collapsed ? 'View More Awards' : 'Collapse'}
        action={!isEditMode ? onViewMoreClick : null}
      >
        {isEditMode ? (
          <HtmlContentBlock content={content} />
        ) : (
          <Collapsable
            isCollapsed={collapsed}
            btnHidden={true}
            maskHidden={
              content.length < 400 && content.split(/\r\n|\r|\n/).length <= 5
            }
          >
            <HtmlContentBlock content={content} />
          </Collapsable>
        )}
      </FirmSection>
    )
  );
};

FirmAboutAwardsSection.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default FirmAboutAwardsSection;
